<template>
  <el-dialog :title="$t('shopSms.edit')" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
    <div class="">
      <div class="">
        <el-form :model="editShopSmsSwitchInfo" label-width="120px">
          <el-form-item :label="$t('shopSms.smsSwitch')" prop="smsSwitch">
            <el-select v-model="editShopSmsSwitchInfo.smsSwitch" style="width:100%"
              :placeholder="$t('shopSms.selectSmsSwitch')">
              <el-option disabled value="">{{ $t('shopSms.selectSmsSwitch') }}</el-option>
              <el-option value="ON">{{ $t('shopSms.on') }}</el-option>
              <el-option value="OFF">{{ $t('shopSms.off') }}</el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div class=" text-right">
          <el-button type="warning" @click="handleClose" style="margin-right:20px;">
            {{ $t('common.cancel') }}
          </el-button>
          <el-button type="primary" @click="editShopSmsSwitch">
            {{ $t('common.save') }}
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { updateShopSmsSwitch } from '@/api/shop/shopSmsApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditShopSmsSwitch',
  data() {
    return {
      dialogVisible: false,
      editShopSmsSwitchInfo: {
        smsId: '',
        shopId: '',
        smsSwitch: ''
      }
    }
  },
  methods: {
    open(data) {
      this.resetForm()
      this.editShopSmsSwitchInfo = { ...data }
      this.editShopSmsSwitchInfo.shopId = getShopId()
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    resetForm() {
      this.editShopSmsSwitchInfo = {
        smsId: '',
        shopId: '',
        smsSwitch: ''
      }
    },
    editShopSmsSwitch() {
      if (!this.validateForm()) {
        return
      }

      updateShopSmsSwitch(this.editShopSmsSwitchInfo).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t('common.saveSuccess'))
          this.handleClose()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    validateForm() {
      if (!this.editShopSmsSwitchInfo.smsSwitch) {
        this.$message.warning(this.$t('shopSms.selectSmsSwitchRequired'))
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
.modal-body {
  padding: 20px;
}

.text-right {
  text-align: right;
}
</style>